export const areAvailableHoursValid = (rules) => Object.values(rules).flat().every(({ error }) => !error)
